import {
  decimalGt,
  decimalGte,
  decimalLikeToDecimal,
  decimalLt,
  decimalLte,
  unknownToDecimal,
} from '@snap-types/schemas/decimal';
import {
  nonNegativeInteger,
  numberFromString,
  positiveInteger,
} from '@snap-types/schemas/number';

const schemaDecimalChecks = {
  gt: decimalGt,
  gte: decimalGte,
  lt: decimalLt,
  lte: decimalLte,
};

export const schema = {
  t: {
    dec: {
      fromDecimalLike: decimalLikeToDecimal,
      fromUnknown: unknownToDecimal,
      checks: schemaDecimalChecks,
    },
    int: {
      nonNegative: nonNegativeInteger,
      positive: positiveInteger,
    },
    num: {
      fromString: numberFromString,
    },
  },
  checks: {
    dec: schemaDecimalChecks,
  },
};
